import Cookies from 'js-cookie';
import { helper } from '@blofin/blofin-utils';
const { isLocalhostInSafari } = helper;

const saveToken = (token: string) => {
  Cookies.set('token', token, { sameSite: 'none', secure: isLocalhostInSafari() ? false : true });
};

const getToken = () => {
  return Cookies.get('token');
};

const removeToken = () => {
  Cookies.remove('token');
};

export { saveToken, getToken, removeToken };
